<template>
  <div class="w-100">
    <div class="f4 text-center font-weight-bold mb-3">
      {{ $t('message.creating', { obj: 'запроса' }) }}
    </div>
    <div class="flex-grow-1 mb-2">
      <custom-select
        v-model="selectedProject"
        :options="projectForks"
        :is-fork-selector="true"
        :placeholder="$t('choose_project')"
      >
        <template slot-scope="{ option }">{{ option.ownerAlias }}/{{ option.alias }} </template>
      </custom-select>
    </div>
    <div class="flex-grow-1 mb-2">
      <project-branch-selector
        :alias="selectedProject?.ownerAlias || this.$route.params.alias"
        :project-model="selectedProject?.alias || this.$route.params.projectAlias"
        :placeholder="$t('select_branch')"
        @input="setValue"
      />
    </div>
    <div>
      <a
        id="createRequestButton"
        :class="{ disabled: !selectedBranch }"
        class="btn btn-sm btn-success btn-block"
        @click.prevent="createMR"
      >
        {{ $t('create_merge_request') }}
      </a>
    </div>
  </div>
</template>
<script>
import CustomSelect from '@shared/shared-components/shared/custom-select';
import RepoS from '@shared/services/repository.service';
import RefS from '@shared/services/reference.service';
import sharedComponentsMessages from '../sharedComponentsMessages';

export default {
  name: 'PreMergeRequestForm',
  components: { CustomSelect },
  data() {
    return {
      selectedBranch: null,
      selectedProject: {},
    };
  },
  computed: {
    projectForks() {
      return [this.selectedProject];
    }
  },
  mounted() {
    RefS.getProjectForks(this.$route.params.alias, this.$route.params.projectAlias).then((res) => {
      const foundProject = res.items.find(
        (item) =>
          item.selectorAlias === this.$route.params.projectAlias &&
          item.selectorOwnerAlias === this.$route.params.alias
      );
      if (foundProject) {
        this.selectedProject = foundProject;
      } else {
        RepoS.getProjectByAlias(this.$route.params.alias, this.$route.params.projectAlias).then(
          (result) => {
            this.selectedProject = result;
          }
        );
      }
    });
  },
  methods: {
    createMR() {
      if (!this.selectedBranch && this.selectedProject) return;
      window.location.href = `/project/${this.$route.params.alias}/${
        this.$route.params.projectAlias
      }/merge-request/create?compare=${encodeURIComponent(this.selectedBranch)}&sourceProjectId=${
        this.selectedProject.id
      }`;
    },
    setValue(e) {
      this.selectedBranch = e.title;
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>
